import { createSlice } from '@reduxjs/toolkit';

type IList = {
  accept_by_org_chief: string;
  all: string;
  id: string;
  name_uz: string;
  negative: string;
  new_overdue: string;
  new_urgent: string;
  overdue_accept: string;
  overdue_reject_conclusion: string;
  overdue_rejected: string;
  positive: string;
  rejected: string;
  sign: string;
  prefix: string;
};

type RequestCommandState = {
  loading: boolean;
  data: IList[];
};

const initialState: RequestCommandState = {
  loading: false,
  data: [],
};

export const getStatisticsByOrgSlice = createSlice({
  name: 'getStatisticsByOrg',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      // @ts-ignore
      state.data = action.payload;
    },
  },
});

export default getStatisticsByOrgSlice.reducer;
